import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Cctv, Cpu, Network, SunMedium, Wind, Zap } from "lucide-react";
import { DOMAINES } from "@/lib/api";
import RecherchePanneIA from "@/components/RecherchePanneIA";
import StatutHoraires from "@/components/StatutHoraires";

const ICONS = { Zap, Cctv, Cpu, Wind, Network, SunMedium };

export default function Declarer() {
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState([]);

  useEffect(() => {
    setDrafts(JSON.parse(localStorage.getItem("bkprod_drafts") || "[]"));
  }, []);

  return (
    <div className="space-y-9" data-testid="declarer-page">
      <div>
        <div className="bk-label mb-2">Nouveau ticket</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter text-slate-900">Quel est le problème ?</h1>
      </div>

      <RecherchePanneIA />

      <StatutHoraires />

      <div>
        <div className="bk-label mb-3">Ou choisissez directement le domaine</div>
        <div className="grid grid-cols-2 gap-4">
          {DOMAINES.map((d, i) => {
            const Icon = ICONS[d.icon];
            return (
              <motion.button
                key={d.key}
                data-testid={`domaine-tile-${d.key}`}
                onClick={() => navigate(`/declarer/${d.key}`)}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
                whileHover={{ y: -4 }}
                className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white text-left aspect-[4/5] sm:aspect-[5/4] focus:ring-2 focus:ring-[#005CFF] focus:outline-none"
              >
                <img src={d.image} alt={d.label} className="absolute inset-0 h-full w-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/25 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-4">
                  <Icon size={22} className="text-white/90 mb-2" strokeWidth={2.2} />
                  <div className="font-display text-lg font-bold text-white leading-tight">{d.label}</div>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>

      {drafts.length > 0 && (
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid="drafts-panel">
          <div className="bk-label mb-2">Brouillons hors-ligne ({drafts.length})</div>
          <p className="text-sm text-slate-600">Vos captures enregistrées sans réseau sont conservées et réutilisables dans le formulaire.</p>
        </div>
      )}
    </div>
  );
}
